import * as React from 'react'

import { NewsfeedEntry, NewsfeedRecordType } from 'core/interfaces'
import { NewsSectionGrid } from 'components/news-section-grid/NewsSectionGrid'
import { DEVELOPER_ARTICLE_CATEGORIES } from 'core/constants'

import classes from './style.module.scss'

interface ComponentProps {
  newsfeed: NewsfeedEntry[]
}

export const NewsSection: React.FC<ComponentProps> = ({ newsfeed }) => {
  // Filter by type, excluding developer categories from articles
  const events = newsfeed.filter((entry) => entry.type === NewsfeedRecordType.Event)
  const articles = newsfeed.filter((entry) => {
    if (entry.type !== NewsfeedRecordType.Article) return false
    return !DEVELOPER_ARTICLE_CATEGORIES.includes(entry.category)
  })

  return (
    <div className={classes.container}>
      <NewsSectionGrid
        title="Events"
        entries={events}
        enableLoadMore
        initialVisibleCount={3}
        itemsPerPage={3}
      />
      <NewsSectionGrid title="Newsroom" entries={articles} />
    </div>
  )
}
